import { Grid2 } from "@mui/material";
import { FleetManagmentTable } from "../FleetManagement/FleetManagementTable.component";

type P = {
  nextStep: () => void;
};

export const FormVehicleSelection: React.FC<P> = ({ nextStep }) => {
  return (
    <Grid2 container data-testid="form-vehicle-select-parent-container">
      <FleetManagmentTable isEditable={false} nextStep={nextStep} />
    </Grid2>
  );
};
